import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { Mail, Phone, Calendar, Home, ArrowRight } from 'lucide-react'

export default function Leads() {
  const [leads, setLeads] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetchLeads() }, [])

  const fetchLeads = async () => {
    const { data } = await supabase.from('leads').select('*').order('created_at', { ascending: false })
    setLeads(data || [])
    setLoading(false)
  }

  if (loading) return <div className="text-center py-8">Loading...</div>

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Leads</h1>
      {leads.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <p className="text-gray-500">No leads yet. Leads appear when someone scans your sign.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {leads.map((lead) => (
            <Link 
              key={lead.id} 
              to={`/leads/${lead.id}`}
              className="block bg-white rounded-lg shadow p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="text-lg font-semibold">{lead.name}</h3>
                    <span className="text-sm text-gray-500">
                      <Calendar size={14} className="inline mr-1" />
                      {new Date(lead.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-3">
                    {lead.email && <span className="flex items-center gap-1"><Mail size={14} />{lead.email}</span>}
                    {lead.phone && <span className="flex items-center gap-1"><Phone size={14} />{lead.phone}</span>}
                    <span className="flex items-center gap-1"><Home size={14} />Code {lead.listing_code}</span>
                  </div>
                  {lead.message && (
                    <p className="text-gray-700 bg-gray-50 p-3 rounded">{lead.message}</p>
                  )}
                </div>
                <ArrowRight size={20} className="text-gray-400 ml-4" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}